"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 15.239 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M10.5 28.359s-.083-4.776.042-5.692c.116-.855.791-1.417 1.188-1.828.247-.256.312-.464.312-.464l.047-1.75h.775c.091.626.5 1.167 1.256 1.167.597 0 1.118-.648 1.119-1.542 0-.894-.484-1.493-1.08-1.538-.595-.045-1.17.33-1.253 1.121l-.796-.015.15-5.568h.604c.091.626.5 1.167 1.256 1.167.597 0 1.118-.648 1.119-1.542 0-.894-.484-1.493-1.08-1.538-.595-.045-1.17.33-1.253 1.121l-.625-.011.135-5.04c-.007-.145-.172-.151-.172-.151s-.701.041-1.239-.195c-.792-.349-.775-.552-1.276-.612-.803-.096-.988-.168-1.261-.24-.254-.068-.426-.188-.624-.188s-.319.076-.639.187c-.172.06-.545.145-1.347.24-.502.06-.442.252-1.233.6-.538.237-1.392.26-1.392.26s-.164.007-.172.152l.031 4.984-.759.014c-.083-.791-.658-1.166-1.254-1.121C.484 10.382 0 10.98 0 11.875c0 .894.522 1.542 1.119 1.542.756 0 1.165-.541 1.256-1.167h.722l.034 5.568-.798.015c-.083-.791-.658-1.166-1.254-1.121C.484 16.757 0 17.356 0 18.25c0 .894.522 1.542 1.119 1.542.756 0 1.165-.541 1.256-1.167h.761l.01 1.661s.037.239.312.464c.459.375 1.192 1.023 1.292 2.042.1 1.018.003 5.567.003 5.567H10.5zm-5.758-9.567a.7.7 0 110-1.4.7.7 0 010 1.4zm.083-6.584a.7.7 0 110-1.4.7.7 0 010 1.4zm5.583-1.4a.7.7 0 110 1.4.7.7 0 010-1.4zm-.083 7.984a.7.7 0 110-1.4.7.7 0 010 1.4z" })));
};
var SvgHeadstockUkuleleFill = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgHeadstockUkuleleFill;
var templateObject_1;
